export const boosterThresholds = [
  { tier: "1", threshold: 30, multiplicator: 0.1 },
  { tier: "2", threshold: 50, multiplicator: 0.2 },
  { tier: "3", threshold: 90, multiplicator: 0.3 },
];

const sortTiersByThreshold = (tiers, direction = "desc") => {
  const sorted = [...(tiers || [])];
  return sorted.sort((a, b) => {
    if (direction === "asc") {
      return a.threshold - b.threshold;
    }
    return b.threshold - a.threshold;
  });
};

export const getReachedTier = (value, tiers = boosterThresholds) => {
  if (!Number.isFinite(value)) return null;
  return sortTiersByThreshold(tiers, "desc").find((tier) => value >= tier.threshold) || null;
};

export const getNextTier = (value, tiers = boosterThresholds) => {
  if (!Number.isFinite(value)) return null;
  return sortTiersByThreshold(tiers, "asc").find((tier) => value < tier.threshold) || null;
};

export const multiplierPercentage = (multiplicator) => Math.round((multiplicator || 0) * 100);
